module.exports = __webpack_public_path__ + "static/media/finish-icon.fbe7f00f.svg";